import { BlockEntity } from "@jackfruit/common"
import { createEntitySlice } from "../createEntitySlice"

const { slice: blocks, selectors: blocksSelector } = createEntitySlice<
  BlockEntity
>("blocks")

export { blocks, blocksSelector }
